import React,{useRef,useState} from 'react';
import API from '../api';
const message=error=>error?.response?.data?.message||error?.response?.data?.error||error?.message||'The local areas could not be recorded. Try again.';
export default function CampaignLocalLayoutPanel({campaign,api=API}){
 const [context,setContext]=useState(null),[open,setOpen]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState(''),[saved,setSaved]=useState(false);
 const pending=useRef(null),base='/v1/veridian/campaigns/'+encodeURIComponent(campaign.campaign_id)+'/local-layout';
 async function load(){const result=await api.get(base);setContext(result.data);}
 async function show(){setOpen(true);setError('');setBusy(true);try{await load();}catch(error){setError(message(error));}finally{setBusy(false);}}
 async function initialize(){
  setError('');setBusy(true);
  try{
   if(!pending.current)pending.current={action_key:window.crypto.randomUUID(),expected_account_version:context.account_version,
    expected_campaign_version:context.campaign_version,settlement_definition_ref:context.settlement_definition.definition_ref,
    expected_settlement_definition_version:context.settlement_definition.definition_version,expected_site_version:context.geography.site_version};
   await api.post(base,pending.current);pending.current=null;setSaved(true);
   await load().catch(()=>setError('Your local areas were recorded. Reload this page to refresh them.'));
  }catch(error){setError(message(error));if(error.response?.status>=400&&error.response?.status<500){pending.current=null;await load().catch(()=>{});}}
  finally{setBusy(false);}
 }
 return <div className="vd-calendar" role="group" aria-label={'Local areas for '+campaign.name}>
  <button type="button" disabled={busy} onClick={show}>Local areas for {campaign.name}</button>
  {open&&<><h4>Starter settlement areas</h4>
   {error&&<p role="alert">{error}</p>}
   {saved&&<p role="status">Settlement and district locations recorded. World time has not advanced.</p>}
   {context?.local_layout&&<><p>{context.local_layout.name} · {context.local_layout.districts.length} district{context.local_layout.districts.length===1?'':'s'} recorded for world setup.</p>
    <ul>{context.local_layout.districts.map(row=><li key={row.district_ref}>{row.name}</li>)}</ul>
    <p>Surveyed sites, homes, workplaces, residents and supplies still need to be established.</p></>}
   {context&&!context.local_layout&&!saved&&context.status==='DRAFT'&&<>
    {context.geography?<><p>Record the settlement and its retained district areas at the starter location.</p>
     <button type="button" disabled={busy} onClick={initialize}>{busy?'Recording areas…':'Record local areas'}</button></>:
     <p>Record the starter location first, then reopen local areas.</p>}
   </>}
   <button type="button" style={{display:'block',marginTop:8}} disabled={busy} onClick={()=>setOpen(false)}>Close local areas</button>
  </>}
 </div>;
}
